import * as LinesTypes from 'store/ducks/lines/types';

/*
 * Action Types
 */
export enum BenefitsTypes {
  LIST_BENEFITS_REQUEST = '@benefits/LIST_BENEFITS_REQUEST',
  LIST_BENEFITS_SUCCESS = '@benefits/LIST_BENEFITS_SUCCESS',
  LIST_BENEFITS_FAILURE = '@benefits/LIST_BENEFITS_FAILURE',

  GET_BENEFIT_REQUEST = '@benefits/GET_BENEFIT_REQUEST',
  GET_BENEFIT_SUCCESS = '@benefits/GET_BENEFIT_SUCCESS',
  GET_BENEFIT_FAILURE = '@benefits/GET_BENEFIT_FAILURE',

  CREATE_BENEFIT_REQUEST = '@benefits/CREATE_BENEFIT_REQUEST',
  CREATE_BENEFIT_SUCCESS = '@benefits/CREATE_BENEFIT_SUCCESS',
  CREATE_BENEFIT_FAILURE = '@benefits/CREATE_BENEFIT_FAILURE',

  ATTACH_BENEFIT_REQUEST = '@benefits/ATTACH_BENEFIT_REQUEST',
  ATTACH_BENEFIT_SUCCESS = '@benefits/ATTACH_BENEFIT_SUCCESS',
  ATTACH_BENEFIT_FAILURE = '@benefits/ATTACH_BENEFIT_FAILURE',

  UPDATE_BENEFIT_REQUEST = '@benefits/UPDATE_BENEFIT_REQUEST',
  UPDATE_BENEFIT_SUCCESS = '@benefits/UPDATE_BENEFIT_SUCCESS',
  UPDATE_BENEFIT_FAILURE = '@benefits/UPDATE_BENEFIT_FAILURE',

  DELETE_BENEFIT_REQUEST = '@benefits/DELETE_BENEFIT_REQUEST',
  DELETE_BENEFIT_SUCCESS = '@benefits/DELETE_BENEFIT_SUCCESS',
  DELETE_BENEFIT_FAILURE = '@benefits/DELETE_BENEFIT_FAILURE',

  LIST_BENEFIT_LINES_REQUEST = '@benefits/LIST_BENEFIT_LINES_REQUEST',
  LIST_BENEFIT_LINES_SUCCESS = '@benefits/LIST_BENEFIT_LINES_SUCCESS',
  LIST_BENEFIT_LINES_FAILURE = '@benefits/LIST_BENEFIT_LINES_FAILURE',

  SET_CURRENT_OPERATION = '@benefits/SET_CURRENT_OPERATION',

  SET_BENEFIT_SELECTED = '@benefits/SET_BENEFIT_SELECTED',
  RESET_BENEFIT_SELECTED = '@benefits/RESET_BENEFIT_SELECTED',
}

/*
 * Data types
 */
export type LineInterface = LinesTypes.LineInterface;

export interface BenefitInterface {
  id: string;
  name: string;
  data: string; // json
  status: number;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  Lines?: Array<LineInterface>;
}

export interface AttachBenefitInterface {
  benefitId: string;
  linesIds: Array<[]>;
  transportOperatorId: string;
}

export interface BenefitLineInterface {
  lineId: string;
  name: string;
  prefix: string;
  active: boolean;
  color: string;
  // type: number;
}

export type OperationTypes = 'none' | 'create' | 'edit';

/*
 * State type
 */
export interface BenefitsState {
  readonly benefitsList: BenefitInterface[];
  readonly benefitData: BenefitInterface;
  readonly benefitCreated: BenefitInterface;
  readonly benefitSelected: BenefitInterface;
  readonly benefitLines: BenefitLineInterface[];
  readonly attachBenefit: AttachBenefitInterface;
  readonly currentOperation: OperationTypes;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
